import RolesTemplate from '../../../components/Templates/Roles/RolesTemplate';

/**
 * @page Roles.tsx
 * @description admin page to assign roles.
 * @return { page }
 */
function Roles() {
  return <RolesTemplate />;
}

export default Roles;
